module.exports = __webpack_public_path__ + "static/media/13.bb23f9b2.jpeg";